import { useCart } from '../../hooks/useCart';
import { useBusinessesContext } from '../../context/BusinessesContext';
import ConfirmModal from '../shared/ConfirmModal';

/**
 * Modal global que se muestra cuando el usuario intenta agregar un producto
 * de otro negocio al carrito (mientras ya hay items de un negocio distinto).
 *
 * Suscribe a `pendingItem` del CartContext: cuando ese state existe, se
 * renderiza el modal pidiendo confirmación para vaciar el carrito y agregar
 * el nuevo producto. Confirmar → `confirmReplaceCart()`; cancelar → `cancelReplaceCart()`.
 *
 * Se monta una sola vez en UnifiedLayout para que esté disponible en cualquier
 * pantalla donde se pueda agregar al carrito.
 */
export default function ReplaceCartConfirm() {
  const { items, pendingItem, confirmReplaceCart, cancelReplaceCart } = useCart();
  const { businesses } = useBusinessesContext();

  if (!pendingItem) return null;

  const currentBusinessId = items[0]?.businessId;
  const newBusinessId = pendingItem.product?.businessId;

  const currentBusiness = businesses?.find(b => (b._id || b.id) === currentBusinessId);
  const newBusiness = businesses?.find(b => (b._id || b.id) === newBusinessId);

  const currentName = currentBusiness?.name || 'otro negocio';
  const newName = newBusiness?.name || 'este negocio';

  return (
    <ConfirmModal
      isOpen={true}
      onClose={cancelReplaceCart}
      onConfirm={confirmReplaceCart}
      title="¿Reemplazar tu carrito?"
      message={
        <>
          Tu carrito tiene productos de <span className="font-semibold text-gray-900">{currentName}</span>.
          ¿Quieres descartarlos y agregar productos de <span className="font-semibold text-gray-900">{newName}</span>?
        </>
      }
      confirmLabel="Sí"
      cancelLabel="No"
    />
  );
}
